import { setTerm } from './helpers';

export const setIsInHiddenBase = setTerm('is_in_hidden_base');
